import styled from 'styled-components'

export const Box = styled.div`
  padding: 12px 0px;
  text-align: center;

  background: ${(props) => props.theme.colors.neutral.grayscale.A100};
  border-radius: 8px;
`
